var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"45px"}},[_c(_vm.toolbarType,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }